import { NavLink } from "react-router-dom";
import { nav as navCopy } from "../../copy/sq";
import { NAV_ITEMS } from "./navItems";

/**
 * A deliberate bottom tab bar for mobile — not a shrunk sidebar. Fixed,
 * touch-friendly (44px+ targets), five items fit comfortably without
 * crowding at common phone widths. `whitespace-nowrap` + a slightly
 * tighter tracking keeps the longest label ("Briefing-et") on one line
 * at iPhone widths rather than wrapping awkwardly.
 */
export function MobileNav() {
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-30 flex border-t border-ink-100 bg-white/95 backdrop-blur lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      aria-label={navCopy.mainNavigationLabel}
    >
      {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/"}
          className={({ isActive }) =>
            `flex min-h-[56px] flex-1 flex-col items-center justify-center gap-0.5 whitespace-nowrap px-0.5 text-[10.5px] font-medium tracking-tight ${
              isActive ? "text-accent-600" : "text-ink-500"
            }`
          }
        >
          <Icon />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
